var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "UiSwitch" }, [
    _c("input", {
      attrs: { type: "checkbox" },
      domProps: { checked: _vm.isChecked },
      on: {
        change: function ($event) {
          return _vm.updateValue($event.target.checked)
        },
      },
    }),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "option yes", class: _vm.isChecked && "is-active" },
      [_vm._v(_vm._s(_vm.labelYes))]
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "option no", class: !_vm.isChecked && "is-active" },
      [_vm._v(_vm._s(_vm.labelNo))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "focus-helper" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }